import React, { useEffect, useRef, useState } from 'react'
import axios from '../axios';
import { TabPanel } from '@mui/lab'
import { Box, Grid, Stepper, Step, StepLabel, Typography, Button } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { useStateValue } from '../StateProvider';
import { actionTypes } from '../reducer';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BusinessIcon from '@mui/icons-material/Business';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import GavelIcon from '@mui/icons-material/Gavel';
import CheckIcon from '@mui/icons-material/Check';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PropTypes from 'prop-types';
import Agreements from '../forms/Agreements';
import BasicInfo from '../forms/BasicInfo';
import BusinessInfo from '../forms/BusinessInfo';
import Confirmation from '../forms/Confirmation';
import Documents from '../forms/Documents';
import Success from '../components/Success';
import Hauling from '../forms/Hauling';
import Equipment from '../forms/Equipment';
import { LocalShipping } from '@mui/icons-material';
import ViewCompactIcon from '@mui/icons-material/ViewCompact';
import StarMenuBar from '../StarMenuBar';

function FormApplication() {
  const navigate = useNavigate();
  const location = useLocation();
  const { search } = location;
  const params = new URLSearchParams(search);
  const uuid = params.get('uuid');

  const [{ applicantDetails, activeStep, goToStep, progressStep, hideHauling }, dispatch] = useStateValue();
  const [applicant, setApplicant] = useState({});
  const applicantDetailsRef = useRef();
  applicantDetailsRef.current = applicantDetails;
  const [formLoadingState, setFormLoadingState] = useState();
  const [showNewBtn, setShowNewBtn] = useState(false);
  const [stepSkip, setStepSkip] = useState({ go: false, targetStep: 0 });

  const ref = useRef();


  useEffect(() => {
    //console.log("uuid", uuid);
    const uuidLocal = localStorage.getItem('applicantSubmissionUUID');

    // if (uuidLocal && JSON.stringify(applicantDetails) === '{}') {
    //   getApplicationSubmission();
    // }

    window.addEventListener('storage', (event) => {
      if (event.key === 'applicantSubmissionUUID') {
        if (event.newValue != undefined) setShowNewBtn(true);
      }
    });

    return () => {
      window.removeEventListener('storage', (event) => {
        if (event.key === 'applicantSubmissionUUID') {
          if (event.newValue != undefined) setShowNewBtn(true);
        }
      });
    }

  }, [showNewBtn]);

  useEffect(() => {

    const handleBeforeUnload = (event) => {
      if (formLoadingState) {
        event.preventDefault();
        event.returnValue = '';
      } else {
        setFormLoadingState(true);

        var formData = new FormData();
        formData.append('operating_agreement_file', applicantDetailsRef.current.operating_agreement_payload || '');
        formData.append('financials_file', applicantDetailsRef.current.financials_payload || '');
        formData.append('open_ar_file', applicantDetailsRef.current.open_ar_payload || '');

        Object.keys(applicantDetailsRef.current.addtional_docs_payload || []).forEach((index) => {
          formData.append('additional_docs_files', applicantDetailsRef?.current.additional_docs_payload[index]);
        });
        ///api/save_partial_documents?application_submission_uuid=${localStorage.getItem('applicantSubmissionUUID')}
        axios.post(``, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          if (response.status === 200) {
            applicantDetailsRef.current.reset();
          } else {
            applicantDetailsRef.current.reset();
          }
        }).catch(err => {
          //console.log(err);
        });
        
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    }

  }, [formLoadingState]);

  // const getApplicationSubmission = () => {
  //   var uuid = localStorage.getItem('applicantSubmissionUUID');
  //   axios.get(``)///api/get_applicant_submission/?application_submission_uuid=${uuid}
  //     .then((response) => {
  //       var item = JSON.parse(response.data.json_application_details.replace(/'/g, '"'));
  //       console.log(item);
  //       dispatch({
  //         type: actionTypes.INIT_APPLICANT_DETAILS,
  //         applicantDetails: item
  //       });
  //       console.log(applicantDetails);
  //     }).catch(err => {
  //       clearUuid();
  //     });
  // }

  const clearUuid = () => {
    localStorage.removeItem('applicantSubmissionUUID');
    dispatch({
      type: actionTypes.SET_APPLICANT_DETAILS,
      applicantDetails: {}
    });
    dispatch({
      type: actionTypes.SET_ACTIVE_STEP,
      activeStep: 0
    });
    setShowNewBtn(false);
    navigate('/');
  }

  const navThruIcon = (e) => {
    dispatch({
      type: actionTypes.SET_ACTIVE_STEP,
      activeStep: e
    });
  }

  const handleChangeStepIcon = (icon) => {
    //console.log("icon click")
    //console.log("progressStep",progressStep)
    let iconNumber = icon - 1;
    if (iconNumber <= progressStep) {
      ref.current?.customStepHandle(iconNumber)
    }
  }

  const handleStepOff = () => {
    setStepSkip({go: false, targetStep: 0})
  }

  const CustomStepIcon = (props) => {
    const { active, completed, icon } = props;
    let stepIcons = {
      1: <AccountCircleIcon sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />,
      2: <BusinessIcon sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />,
      3: <LocalShipping sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />,
      4: <ViewCompactIcon sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />,
      5: <FileUploadIcon sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />,
      6: <GavelIcon sx={{ fontSize: 35, color: activeStep == (icon - 1) ? "#007FB0 !important" : (icon - 1) <= progressStep ? "#0ea723 !important" : "" }} />,
      7: <CheckIcon sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />,
      8: <DoneAllIcon sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />
    }
    if (hideHauling) {
      stepIcons = {
        1: <AccountCircleIcon sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />,
        2: <BusinessIcon sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />,
        //3: <LocalShipping sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />,
        3: <ViewCompactIcon sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />,
        4: <FileUploadIcon sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />,
        5: <GavelIcon sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />,
        6: <CheckIcon sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />,
        7: <DoneAllIcon sx={{ fontSize: 35, color: activeStep == (icon-1) ? "#007FB0 !important" : (icon-1) <= progressStep ? "#0ea723 !important" : "" }} />
      }
    }
    //console.log("activeStep",activeStep);
    //console.log("progressStep",progressStep);
    return (
      <div onClick={() => handleChangeStepIcon(icon)}>
        {stepIcons[String(props.icon)]}
      </div>
    );

  }

  const steps = [
    {
      label: `Basic Information`,
      description: `Now, let's gather some Basic Information.`
    },
    {
      label: `Business Information`,
      description: `Now some Business Information and Ownership.`
    },
    {
      label: `Hauling`,
      description: `Hauling Reference`
    },
    {
      label: `Equipment`,
      description: `Equipment you’re looking to finance`
    },
    {
      label: `Documents`,
      description: `Upload your underwriting documents for easy verification.`
    },
    {
      label: `Agreements`,
      description: `Take a look at these documents.`
    },
    {
      label: `Confirmation`,
      description: `Let's Review your Information Before Submitting`
    },
    {
      label: 'Success',
      description: `Congratulations.`,

    },
  ];

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            {children}
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  }
  
  useEffect(() => {
    //console.log("isMcAuthority",isMcAuthority);
    localStorage.clear();
  }, [])
  //console.log(applicantDetails);
  return (
    <>
        <StarMenuBar title="TAB Online Application" />
        <Grid marginTop={4} container>
          <Grid sx={{ display: { xs: 'block', md: 'none' }, overflowX: 'scroll', paddingLeft: '24px' }}>
            <Stepper activeStep={activeStep} orientation="horizontal" sx={{ position: 'sticky' }}>
            {steps.map((step, index) => {
              if (index == 2 && hideHauling) {
                return null;
              }
              return (
                <Step key={step.label}>
                  <StepLabel StepIconComponent={CustomStepIcon}></StepLabel>
                </Step>
              )
            }
            )}
            </Stepper>
          </Grid>
        
          <Grid item sx={{ display: { xs: 'block', md: 'none' }, width: "24px" }}></Grid>

          <Grid item xs={12} sm={12} md={4} lg={4} xl={4} sx={{ display: { xs: 'none', md: 'block' } }}>
            <Stepper activeStep={activeStep} orientation="vertical" sx={{ position: 'sticky', top: '1rem' }}>
            {steps.map((step, index) => {
              if (index==2 && hideHauling) {
                return null;
              }
              return (
                <Step key={step.label} sx={{ minWidth: '24px', marginRight: '24px' }}>
                  <StepLabel StepIconComponent={CustomStepIcon}>
                    <Typography sx={{ fontSize: '16px', margin: 'auto' }}>{step.label}</Typography>
                    <br />
                    <Typography sx={{ marginLeft: '24px' }} variant="caption">
                      {step.description}
                      {/* {index == 2 && applicantDetails?.isMcAuthority == "true" && <span style={{ color: "red" }}> (SKIPPED) Use own MC Authority</span>} */}
                    </Typography>
                  </StepLabel>
                </Step>
              )
            }
              )}
            </Stepper>
            {/* {localStorage.getItem('applicantSubmissionUUID') &&
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4} sx={{ float: 'inline-end !important', marginTop:'10px',position: 'sticky', top: '40rem' }}>
                <Typography sx={{marginBottom:'10px', fontSize: '16px',color:'rgb(122,123,124)'}}>Or</Typography>
                <Button sx={{marginRight:'20px'}} color='success' variant="contained" onClick={clearUuid}>Create a New Application</Button>
              </Grid> 
            } */}
          </Grid>
        {!hideHauling ? (
          <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
            <TabPanel value={activeStep} index={0}>
              <BasicInfo stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
            <TabPanel value={activeStep} index={1}>
              <BusinessInfo stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
            <TabPanel value={activeStep} index={2}>
              <Hauling stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
            <TabPanel value={activeStep} index={3}>
              <Equipment stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
            <TabPanel value={activeStep} index={4}>
              <Documents stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
            <TabPanel value={activeStep} index={5}>
              <Agreements stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
            <TabPanel value={activeStep} index={6}>
              <Confirmation stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
            <TabPanel value={activeStep} index={7}>
              <Success stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
          </Grid>
        ) : (
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
            <TabPanel value={activeStep} index={0}>
              <BasicInfo stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
            <TabPanel value={activeStep} index={1}>
              <BusinessInfo stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
            {/* <TabPanel value={activeStep} index={2}>
              <Hauling stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel> */}
            <TabPanel value={activeStep} index={2}>
              <Equipment stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
            <TabPanel value={activeStep} index={3}>
              <Documents stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
            <TabPanel value={activeStep} index={4}>
              <Agreements stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
            <TabPanel value={activeStep} index={5}>
              <Confirmation stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
            <TabPanel value={activeStep} index={6}>
              <Success stepSkipParent={stepSkip} handleStepOff={handleStepOff} ref={ref} />
            </TabPanel>
          </Grid>
          )}
        </Grid>
      </>
  )
}

export default FormApplication
